// import the translations from the JSON files
import ro from '../../../lang/ro.json';
import custom_ro from '../../../lang/custom_ro.json';
import custom_de from '../../../lang/custom_de.json';
import custom_fr from '../../../lang/custom_fr.json';
import custom_es from '../../../lang/custom_es.json';
import custom_hu from '../../../lang/custom_hu.json';
import custom_uk from '../../../lang/custom_uk.json';
import custom_pol from '../../../lang/custom_pol.json';
import es from '../../../lang/es.json';
import fr from '../../../lang/fr.json';
import de from '../../../lang/de.json';
import hu from '../../../lang/hu.json';
import uk from '../../../lang/uk.json';
import pol from '../../../lang/pol.json';
import { nextTick } from 'vue';

export const __ = (value, replacements = {}) => {
  const lang = localStorage.getItem('locale');
  const languageMappings = {
    ro: ro,
    es: es,
    de: de,
    fr: fr,
    hu: hu,
    uk: uk,
    pol: pol,
    custom_ro: custom_ro,
    custom_de: custom_de,
    custom_es: custom_es,
    custom_fr: custom_fr,
    custom_hu: custom_hu,
    custom_uk: custom_uk,
    custom_pol: custom_pol
  };

  const selectedLanguage = languageMappings[lang];

  let translatedValue = null;

  if (selectedLanguage && selectedLanguage[value])
    translatedValue = selectedLanguage[value];
  else if (
    languageMappings['custom_' + lang] &&
    languageMappings['custom_' + lang][value]
  )
    translatedValue = languageMappings['custom_' + lang][value];
  else translatedValue = value;

  Object.keys(replacements).forEach((key) => {
    translatedValue = translatedValue.replace(`{${key}}`, replacements[key]);
  });

  return translatedValue;
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const scrollToBottom = async () => {
  await nextTick();
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: 'smooth'
  });
};

export const redirectToPage = (name, params) => {
  window.location.href = route(name, params);
};
